/**
 * Floating Navigation JS
 * - Syncs cart count with real header
 * - Hamburger triggers original mobile drawer
 * - Search/cart icons open drawers directly
 * - Marks active nav link based on current URL
 */

(function () {
  'use strict';

  var floatingNav = document.getElementById('floating-nav');
  if (!floatingNav) return;

  // ── Helper: open a Focal drawer by element ID ────────────
  function openDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return false;

    // Focal theme uses a custom element with an .open() method
    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Fallback: set open attribute + dispatch custom event
    drawer.setAttribute('open', '');
    drawer.removeAttribute('hidden');
    drawer.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    return true;
  }

  // ── Helper: find and click a real (hidden) toggle button ─
  // Focal's toggle-button custom element wires up drawer logic
  // on connectedCallback — clicking the real button is the
  // most reliable way to trigger it even when visually hidden.
  function clickOriginalToggle(selector) {
    var btn = document.querySelector(selector);
    if (!btn) return false;
    // Temporarily restore pointer-events so click fires
    var prev = btn.style.pointerEvents;
    btn.style.pointerEvents = 'auto';
    btn.click();
    btn.style.pointerEvents = prev;
    return true;
  }

  // ── Active link highlight ────────────────────────────────
  var currentPath = window.location.pathname.replace(/\/$/, '');

  var allLinks = floatingNav.querySelectorAll(
    '.floating-nav__menu-link, .floating-nav__carousel-link'
  );

  allLinks.forEach(function (link) {
    var linkPath = link.getAttribute('href');
    if (!linkPath) return;
    linkPath = linkPath.replace(/\/$/, '');
    if (
      currentPath === linkPath ||
      (linkPath !== '' && currentPath.startsWith(linkPath))
    ) {
      link.classList.add('is-active');
    }
  });

  // ── Cart count sync ──────────────────────────────────────
  var cartCountEl = floatingNav.querySelector('.floating-nav__cart-count');

  function syncCartCount(count) {
    if (!cartCountEl) return;
    count = parseInt(count, 10) || 0;
    cartCountEl.textContent = count > 0 ? count : '';
    cartCountEl.setAttribute('data-count', count);
  }

  // Init from main header cart-count element
  var mainCartCount = document.querySelector('.header__cart-count');
  if (mainCartCount) {
    syncCartCount(mainCartCount.textContent);
  }

  // Listen for Focal theme cart:updated event
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
    syncCartCount(count);
  });

  // MutationObserver fallback
  if (mainCartCount && window.MutationObserver) {
    new MutationObserver(function () {
      syncCartCount(mainCartCount.textContent);
    }).observe(mainCartCount, { childList: true, characterData: true, subtree: true });
  }

  // ── Hamburger → opens mobile menu drawer ─────────────────
  var hamburgerBtn = floatingNav.querySelector('.floating-nav__hamburger');
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Strategy 1: find the real hidden hamburger in store-header and click it
      // This triggers Focal's built-in toggle-button logic
      if (clickOriginalToggle('store-header [aria-controls="mobile-menu-drawer"]')) {
        return;
      }

      // Strategy 2: open the drawer directly via its custom element method
      if (openDrawer('mobile-menu-drawer')) {
        return;
      }

      // Strategy 3: manual fallback toggle
      var drawer = document.getElementById('mobile-menu-drawer');
      if (!drawer) return;
      var isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-visible');
      if (isOpen) {
        drawer.removeAttribute('open');
        drawer.classList.remove('is-visible');
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('drawer-open');
      } else {
        drawer.setAttribute('open', '');
        drawer.classList.add('is-visible');
        hamburgerBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('drawer-open');
      }
    });
  }

  // ── Search icon → opens search drawer ────────────────────
  var searchBtn = floatingNav.querySelector('[data-floating-search]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();

      // Try clicking real toggle button first (preserves Focal's logic)
      if (clickOriginalToggle('[aria-controls="search-drawer"]')) return;

      // Fallback: open drawer directly
      if (!openDrawer('search-drawer')) {
        window.location.href = '/search';
      }
    });
  }

  // ── Cart icon → opens mini-cart drawer ───────────────────
  var cartBtn = floatingNav.querySelector('[data-floating-cart]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();

      // Try clicking real toggle link first
      if (clickOriginalToggle('[aria-controls="mini-cart"]')) return;

      // Fallback: open drawer directly
      if (!openDrawer('mini-cart')) {
        window.location.href = '/cart';
      }
    });
  }

})();